<section class="contract-list-item">
    <section class="title-section">
        <h3>
            <a ng-click="openDocument($event)" ng-bind-html="item.title|cHighlight:highlight"></a>
        </h3>
    </section>
    <section class="menu-section">
        <a class="details" ng-class="{isFavorite: workflow.IsFavorite}" ng-click="onFavoritesClick(workflow, $event)" ng-attr-title="{{ 'workflowList.favorite'|translate }}">
            <i class="fa fa-star-o" ng-if="!workflow.IsFavorite"></i>
            <i class="fa fa-star isFavorite" ng-if="workflow.IsFavorite"></i>
        </a>
        <a class="details button" ng-click="viewDetails($event)" ng-attr-title="{{ 'workflowList.details'|translate }}"><i class="fa fa-info"></i></a>
    </section>
    <p ng-bind-html="(item.snippet ? item.snippet + '...' : item.snippet)|cHighlight:highlight" class="description">
    </p>
    <div class="property-container">
        <ul class="workflow-property-list">
            <li ng-bind-html="item.category | cHighlight:highlight"></li>
            <li>{{'contract.startDate'|translate}}: {{ item.startTime | cDate }}</li>
            <li>{{'contract.owner'|translate}}: {{ item.owner }}</li>
            <li ng-if="item.endTime">{{'contract.endDate'|translate}}: {{ item.endTime | cDate }}</li>
            <li ng-if="item.period">{{'contract.period'|translate}}: {{ item.period | cTimespan }}</li>
            <li ng-if="item.deadline">{{'contract.deadline'|translate}}: {{ item.deadline | cDate }}</li>
        </ul>
    </div>
</section>